import React, { useRef, useState } from "react";
import { ArrowLeft, ArrowRight } from 'lucide-react';
import "./reviews.css";

const reviewsData = [
  {
    name: "Pablo",
    date: "março 21, 2024",
    highlight: "Trabalho enriquecedor",
    review:
      "Compartilho do mesmo sentimento. Já fiz as disciplinas que circuitos 1 e 2 na faculdade, que na minha vai até circuitos trifásicos, e acompanho seu trabalho porque percebi que é nos detalhes, no básico onde deixamos de aprender muita coisa, na correria que é na universidade, acaba que aprendemos de qualquer maneira apenas pra obter a aprovação. Voltando e acompanhando suas aulas estou preenchendo as lacunas que ficaram e estou aprendendo muito mais. E realmente é como você falou, a realidade das universidades são essas, os alunos passam e não aprendem direito, também vindo de um ensino médio precário e essa é a realidade de muitos, a maioria. ITA, Unicamp, USP são pontos fora da curva, mas é uma minoria. Seu trabalho é enriquecedor porque trabalha justamente a deficiência da galera que teve um ensino médio defasado e uma faculdade com muita dificuldade. Continua que está ajudando muita gente e é o importante.",
  },
  {
    name: "Julie",
    date: "março 21, 2024",
    highlight: "Admiro muito o trabalho",
    review:
      "Acredito que suas aulas são maravilhosas. Desde o ano passado venho acompanhando seu trabalho, e encontrei o canal quando estava em um momento de muitos estudos do meu curso (provas e muitas listas de exercícios), gostei tanto das aulas que comprei o curso. Acredito que você vai construindo o conhecimento do aluno, e isso é mais do que importante. Porque não adianta ensinar o 'avançado' antes de ensinar a base das coisas, na minha Universidade esse é o maior pecado dos professores da disciplina de Circuitos Eletrônicos... Além disso, você segue as principais bibliografias, isso em qualquer universidade bem conceituada (como o Sadiku, Nilsson...), destrinchando os exercícios, o que permite um processo de ensino-aprendizagem de muita qualidade. E é isso... Admiro muito seu trabalho, e é um investimento que vale MUITO a pena. 🤝🍀",
  },
  {
    name: "André Luiz Leite Carlos",
    date: "janeiro 5, 2023",
    highlight: "Clareza",
    review: `Aula muito esclarecedora.
Não aprendi isso na faculdade. Era tudo engessado. Só podia usar um método de cada vez.
Agora estou entendendo os conceitos e como usar.`,
  },
  {
    name: "Messias Aparecido da Costa",
    highlight: "Resolução mais fácil",
    date: "dezembro 31, 2022",
    review: `Bom dia a todos! Parabéns pela aula Nicholas.
Realmente, transformar fontes ajuda na simplificação do circuito, tornando mais fácil a resolução.`,
  },
  {
    name: "Davi Ferreira Leite",
    date: "dezembro 5, 2022",
    highlight: "Gosto muito da didática",
    review: `Boa tarde! Já acompanhava o canal do elétron há um tempo e gosto muito da sua didática.
Estava ansioso para o começo do curso e espero aproveitar bastante os conteúdos que vou aprender aqui, obg por disponibilizar essas aulas professor.`,
  }, 
  {
    name: "Haron",
    date: "julho 10, 2020",
    highlight: "Preenchendo lacunas",
    review:
      "Olá Nicholas, estou fazendo seu curso estou gostando da ordem cronológica das matérias estou fazendo no meu tempo, eu sou estudante de engenharia elétrica e com esse material me sinto confiante para lá na frente quando me formar dar aula sobre esse assunto como o senhor. Assim quando você dar aula no presencial por matérias como na faculdade, qual seu roteiro por matérias tipo Circuitos I página 1-60 fundamentos de circuitos elétricos, exemplos de provas trabalhos, Como se eu fosse dar aula nessa área, poderia me mandar o material, eu sei que seu curso tem exatamente mas no presencial é a mesma coisa do Domínio Elétrico, eu sou do interior de Rondônia e é bem difícil de achar emprego bem remunerado, assim eu tenho que me preparar. Desde já agradeço, esse curso ajuda muito a preencher lacunas no meu conhecimento.",
  },
  {
    name: "Oséias Ferreira Barros",
    date: "agosto 6, 2022",
    highlight: "Aulas excelentes",
    review:
      "Suas aulas são excelentes, dá para perceber seu esforço em elaborá-las.",
  },
  {
    name: "Marcelo de Lima Carvalho",
    date: "dezembro 7, 2022",
    highlight: "Muito valor para a formação",
    review:
      "Já acompanhava o canal e agora felizmente posso iniciar meu aprendizado com o professor Nicholas. Estou muito ansioso e espero finalizar. Sei que vai ser de muito valor para minha formação em engenharia elétrica. Desde já agradeço!",
  }
];

function Reviews() {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -300,
        behavior: "smooth"
      });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: 300,
        behavior: "smooth"
      });
    }
  };

  const [expandedReview, setExpandedReview] = useState(null);
  const avatarGradients = [
    "linear-gradient(135deg, #072959, #2b6cb0)",
    "linear-gradient(135deg, #0b3978, #3b82c4)",
    "linear-gradient(135deg, #072959, #4a90d9)",
    "linear-gradient(135deg, #10386f, #2b6cb0)",
    "linear-gradient(135deg, #072959, #1e5fa8)",
  ];

  const getAvatarGradient = (name) => {
    const index = name.length % avatarGradients.length;
    return avatarGradients[index];
  };

  return (
  <section className="reviews-section">
    <div className="carousel-header">
      <div className="blur">
        <h2>Nossos alunos </h2>
      </div>
      <div className="carousel-arrows">
          <button onClick={scrollLeft} className="carousel-arrow-btn">
            <ArrowLeft size={18} />
          </button>
          <button onClick={scrollRight} className="carousel-arrow-btn">
            <ArrowRight size={18} />
          </button>
        </div>
    </div>

    <div className="carousel-wrapper" ref={scrollRef}>
      {reviewsData.map((review, idx) => (
        <div
          key={idx}
          className="review-card"
          onClick={() => setExpandedReview(review)}
        >
          <div className="review-top-bar"></div>

          <div className="review-badge">
            {review.highlight}
          </div>

          <div className="quote-mark">“</div>

          <div className="review-header">
            <div
              className="review-avatar"
              style={{
                background: getAvatarGradient(review.name)
              }}
            >
              {review.name.charAt(0)}
            </div>

            <div>
              <h3>{review.name}</h3>
              {/* <p className="review-date">{review.date}</p> */}
            </div>
          </div>

          <p className="review-text">
            {review.review.length > 140
              ? review.review.slice(0, 140) + "..."
              : review.review}
          </p>

          <div className="review-read-more">
            Ler depoimento →
          </div>
        </div>
      ))}
    </div>

    {expandedReview && (
      <div
        className="review-overlay"
        onClick={() => setExpandedReview(null)}
      >
        <div
          className="review-overlay-content"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <div>
              <div className="review-badge large">
                {expandedReview.highlight}
              </div>

              <div className="review-header">
                <div
                  className="review-avatar"
                  style={{
                    background: getAvatarGradient(expandedReview.name)
                  }}
                >
                  {expandedReview.name.charAt(0)}
                </div>

                <div>
                  <h3>{expandedReview.name}</h3>
                  {/* <p className="review-date">{expandedReview.date}</p> */}
                </div>
              </div>
            </div>

            <button
              className="close-x"
              onClick={() => setExpandedReview(null)}
            >
              ×
            </button>
          </div>

          <p className="review-full-text">
            {expandedReview.review}
          </p>
        </div>
      </div>
    )}
  </section>
);
}

export default Reviews;
